<template>
  <mdb-container>
    <mdb-card class="text-left mb-4">
      <mdb-card-body>
        <mdb-btn :disabled="executing" @click="doCancel" rounded size="sm">
          <mdb-icon icon="arrow-left"/>
          Back to Main
        </mdb-btn>
        <mdb-tbl bordered class="mb-4" responsive striped>
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>Member</th>
              <th>Event Charge</th>
              <th>Balance Due<sup>*</sup></th>
              <th>&nbsp;</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr :key="i" v-for="(p,i) in paymentData">
              <td>
                <avatar :avatar="p.avatar" :size="45"/>
                {{ p.name }}
              </td>
              <td class="text-right">{{ p.charges }}
                <a href="" @click.prevent="editCharge(p)">
                  <mdb-icon icon="pencil" color="danger"/>
                </a>
              </td>
              <td class="text-right">{{ p.balance }}</td>
              <td>
                <mdb-btn @click="recalculate(p)" color="warning" icon="calculator" rounded size="sm">Recalculate
                </mdb-btn>
                <mdb-btn @click="record(p)" color="success" icon="pencil" rounded size="sm">Record Payment</mdb-btn>
                <mdb-btn v-if="p.balance >0" @click="chargeCard(p)" color="warning" icon="credit-card" rounded size="sm">Charge Credit Card</mdb-btn>
                <mdb-btn @click="$router.push('/conversations/?start=' + p.userId)" icon="envelope"
                         rounded size="sm" v-if="p.userId != userDetails.id">Send Message
                </mdb-btn>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <mdb-card>
          <mdb-card-body>
            <div class="small text-info">
              <sup>*</sup>Balance due is for all charges made by {{ group.name }}, not just this event.
            </div>
            If you added or changed a fee after people have signed up, you can recalculate for everyone:
            <mdb-btn @click="recalculateAll" color="warning" icon="calculator" rounded size="sm">Recalculate All
            </mdb-btn>
          </mdb-card-body>
        </mdb-card>

        <payment-modal :name="modalRow.name" @cancel="showRecordTransaction=false" @save="saveTransaction"
                       v-if="showRecordTransaction"/>
      </mdb-card-body>
    </mdb-card>

    <mdb-modal class="text-center" v-show="showChargeModal">
      <mdb-modal-header :close="true" center class="secondary-color">
        <p class="heading">Edit Charge</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="input-charge" :step="0.01" type="number"
                   @keydown.native="chargeKeydown"
                   v-model="editingCharge" label="Amount" placeholder="Amount"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click="showChargeModal = false" color="danger" icon="times-circle">Cancel</mdb-btn>
        <mdb-btn @click="saveCharge" color="success" icon="save">Save</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

  </mdb-container>

</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";
import PaymentModal from "../common/PaymentModal";
import Vue from "vue";

export default {
  name: 'payment-history',
  components: {
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbChip,
    mdbTblBody,
    mdbInput,
    mdbTblHead,
    mdbTbl,
    mdbIcon,
    Avatar,
    PaymentModal
  },
  props: {
    event: {
      type: Object,
      default: []
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    group() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    }
  },

  data() {
    return {
      paymentData: [],
      showRecordTransaction: false,
      showChargeModal: false,
      editingCharge: 0,
      modalRow: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true);
    api.get("/event/paymentData/" + this.event.eventId).then(
        (results) => {
          this.paymentData = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load data. " + error.response.data, timeOut: 20000})
        }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    editCharge(p) {
      this.modalRow = p
      this.editingCharge = p.charges
      this.showChargeModal = true
      Vue.nextTick().then(() => {
        let el = document.getElementById("input-charge")
        if (el) {
          el.focus();
          el.select();
        }
      })
    },
    record(p) {
      this.modalRow = p
      this.showRecordTransaction = true
    },
    chargeKeydown(e) {
      console.log("Got to keydown")
      if (e.keyCode == 13) {
        Vue.nextTick().then(() => {
          console.log("next tick.")
          this.saveCharge()

        });
      }
    },
    saveCharge() {
      let payload = { reservationId: this.modalRow.reservationId, charge: this.editingCharge}
      this.$store.dispatch("setExecuting", true)
      api.post("/event/editCharge/", payload).then(
          (results) => {
            this.modalRow.balance = results.data.balance
            this.modalRow.charges = results.data.charges
            this.modalRow.chargesNumeric = results.data.chargesNumeric
            this.modalRow = null
            this.editingCharge = 0
            this.showChargeModal = false
          },
          (error) => {
            this.$notify.error({message: "Could not load data. " + error.response.data, timeOut: 20000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    saveTransaction(trans) {
      trans.reservationId = this.modalRow.reservationId
      this.showRecordTransaction = false
      this.$store.dispatch("setExecuting", true);
      api.post("/event/recordPayment/" + this.event.eventId, trans).then(
          (results) => {
            this.modalRow.balance = results.data.balance
            this.modalRow.charges = results.data.charges
          },
          (error) => {
            this.$notify.error({message: "Could not load data. " + error.response.data, timeOut: 20000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    doCancel() {
      this.$emit("close")
    },
    chargeCard(h) {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/chargeCard/" + this.event.eventId, {reservationId: h.reservationId}).then(
        (results) => {
          h.balance = results.data.balance
          h.charges = results.data.charges
        },
        (error) => {
          this.$notify.error({message: "Could not process payment. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    recalculate(h) {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/recalculateCharge/" + this.event.eventId, {reservationId: h.reservationId}).then(
          (results) => {
            h.balance = results.data.balance
            h.charges = results.data.charges
          },
          (error) => {
            this.$notify.error({message: "Could not load data. " + error.response.data, timeOut: 20000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    recalculateAll() {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/recalculateAll/" + this.event.eventId).then(
          (results) => {
            this.paymentData = results.data
          },
          (error) => {
            this.$notify.error({message: "Could not load data. " + error.response.data, timeOut: 20000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
;
</script>
